module.exports = __webpack_public_path__ + "media/images/flags/64/Djibouti-1b603219af0cc861ded4a056519da8ab.png";